import React, { useState } from 'react';
import './AlertaBanner.css';


const AlertaBanner = ({ problemas, onRefresh, isChecking: isCheckingProp }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  const temProblemas = problemas.length > 0 && !isDismissed;

  const handleRefresh = () => {
    if (onRefresh) onRefresh();
  };

  const handleDismiss = () => {
    setIsDismissed(true);
    // Auto-reativa após 10 minutos para não perder alertas importantes
    setTimeout(() => setIsDismissed(false), 10 * 60 * 1000);
  };

  // Agora o backend deve enviar o campo tempoOfflineFormatado ou tempoSemDadosFormatado já pronto

  const obterNumeroReservatorio = (problema) => {
    // Prioridade 1: Campo numero_reservatorio da base de dados
    if (problema.numero_reservatorio) {
      return problema.numero_reservatorio;
    }
    
    // Prioridade 2: UID completo do módulo
    return problema.uid || '?';
  };

  return (
    <div className={`alerta-banner ${!temProblemas ? 'alerta-banner--vazio' : ''}`}>
      {temProblemas && (
        <div className="alerta-content">
          <div className="alerta-icon">⚠️</div>
          <div className="alerta-texto">
            <div className="alerta-principal">
              <strong>Problemas Detectados</strong>
              <span className="alerta-count">
                {problemas.length} reservatório{problemas.length > 1 ? 's' : ''} offline
              </span>
            </div>
            
            {isExpanded && (
              <div className="alerta-detalhes">
                {problemas.map((problema, index) => (
                  <div key={`${problema.modulo_id}-${problema.nome || problema.canal || index}`} className="problema-item">
                    <div className="problema-info-simplificada">
                      <span className="reservatorio-numero">
                         Reservatório {obterNumeroReservatorio(problema)} - Bloco {problema.bloco}
                      </span>
                      <span className="reservatorio-ultima-medicao">
                        {['sem_dados', 'canal_sem_dados'].includes(problema.status)
                          ? (problema.tempoSemDadosFormatado
                              ? `Tempo Sem Dados: ${problema.tempoSemDadosFormatado}`
                              : 'Nenhuma medição encontrada')
                          : (problema.tempoOfflineFormatado
                              ? `Tempo Offline: ${problema.tempoOfflineFormatado}`
                              : (problema.ultimaAtualizacao
                                  ? `Última medição: ${problema.ultimaAtualizacao}`
                                  : 'Sem informação de tempo'))
                        }
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          
          <div className="alerta-actions">
            <button 
              className="alerta-btn alerta-toggle"
              onClick={() => setIsExpanded(!isExpanded)}
              title={isExpanded ? "Ocultar detalhes" : "Ver detalhes"}
            >
              {isExpanded ? '−' : '+'}
            </button>
            

            <button 
              className="alerta-btn alerta-refresh"
              onClick={handleRefresh}
              disabled={isCheckingProp}
              title="Verificar novamente"
            >
              <span className={isCheckingProp ? 'refresh-icon spinning' : 'refresh-icon'}>
                ↻
              </span>
            </button>
            
            <button 
              className="alerta-btn alerta-dismiss"
              onClick={handleDismiss}
              title="Dispensar por 10 minutos"
            >
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AlertaBanner;
